import { render, staticRenderFns } from "./CourierSelect.vue?vue&type=template&id=25a02c80&scoped=true"
import script from "./CourierSelect.vue?vue&type=script&lang=js"
export * from "./CourierSelect.vue?vue&type=script&lang=js"
import style0 from "./CourierSelect.vue?vue&type=style&index=0&id=25a02c80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a02c80",
  null
  
)

export default component.exports